export default __webpack_public_path__ + "static/media/logo-tnvdr.3ca1d112.svg";